<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                :title="position ? 'Position bearbeiten' : 'Position hinzufügen'"
                @ok="submit" :loading="loading" ok-text="Überschreiben"
                @cancel="close">
            <form>
                <Input v-model="name" :disabled="true" label="Name"></Input>
                <div style="font-size: 16px">
                    Bitte angeben, welche Werte überschrieben werden sollen.
                </div>
                <Toggle v-for="(toggle, i) in formSwitches" :key="'switch_'+i"
                        :label="toggle.label"
                        v-model="$data[toggle.vModel]"
                ></Toggle>
            </form>
        </Dialog>
        <Snackbar v-model="successSnackbar" color="success">Positionsänderung erfolgreich auf alle Parents
            überschrieben.
        </Snackbar>
    </div>
</template>

<script>
import Input from "../../../components/Inputs/Input";
import Toggle from "../../../components/buttons/Toggle";
import Dialog from "../../../components/Dialog";
import Snackbar from "../../../components/Snackbar";

export default {
    name: "OverwritePositionsDialog",
    components: {Snackbar, Dialog, Toggle, Input},
    props: ['value', 'position'],
    data: () => {
        return {
            name: null,
            loading: false,
            successSnackbar: false,
            slotStatus: 0,
            splitQueue: 0,
            lazyLoad: 0,
            adLabel: 0,
            posVar: 0
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        vuexState() {
            return this.$store.state.zones;
        },
        selectedSite() {
            return this.$store.state.display.selectedSite;
        },
        selectedType() {
            return this.$store.state.display.selectedType;
        },
        formSwitches() {
            return [
                {
                    vModel: 'slotStatus',
                    label: 'Slot Status',
                },
                {
                    vModel: 'splitQueue',
                    label: "Split Queue",
                },
                {
                    vModel: 'lazyLoad',
                    label: "Lazy Loading",
                },
                {
                    vModel: 'adLabel',
                    label: 'Anzeigenkennzeichnung',
                },
                {
                    vModel: 'posVar',
                    label: 'Pos Variable',
                }
            ];
        },

    },
    methods: {
        init() {
            this.name = this.position ? this.position.PositionName.Name : null;
            this.slotStatus = 0;
            this.posVar = 0;
            this.lazyLoad = 0;
            this.splitQueue = 0;
            this.adLabel = 0;
        },
        async submit() {
            this.loading = true;
            let data = await this.$store.dispatch('zones/savePositionToAll', this.getBody());
            if (data.Status) {
                this.successSnackbar = true;
                this.close();
            }
            this.loading = false;
        },
        getBody() {
            return {
                publisher_id: this.selectedSite.PublisherId,
                site_id: this.selectedSite.SiteId,
                type_id: this.selectedType.SitetypeId,
                zone_id: this.vuexState.zoneDetails.Zone.ZoneId,
                Status: this.slotStatus,
                splitQueue: this.splitQueue,
                LazyLoad: this.lazyLoad,
                AdLabel: this.adLabel,
                Position: this.posVar,
                position_id: this.position.PositionId,
            };
        },
        close() {
            this.init();
            this.$emit('input', false);
        }
    },
    watch: {
        position() {
            this.init();
        }
    }
}
</script>

<style scoped>

</style>